'use strict'

module.exports = {
  SET_CONNECTED_COMPONENTS: 'SET_CONNECTED_COMPONENTS'
}



// WEBPACK FOOTER //
// ./connectedComponents/actionTypes.js